import React from "react";

const Step1CompanyDetails = ({ register, errors }) => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="form-group">
          <label className="form-label">Company Legal Name</label>
          <input
            type="text"
            {...register("companyLegalName")}
            className="form-input"
            placeholder="Amazon Inc."
          />
          {errors.companyLegalName && (
            <span className="form-error">{errors.companyLegalName.message}</span>
          )}
        </div>

        <div className="form-group">
          <label className="form-label">Friendly Name</label>
          <input
            type="text"
            {...register("companyFriendlyName")}
            className="form-input"
            placeholder="Amazon Warehouse"
          />
          {errors.companyFriendlyName && (
            <span className="form-error">{errors.companyFriendlyName.message}</span>
          )}
        </div>
      </div>

      <div className="form-group">
        <label className="form-label">Facility Type</label>
        <select {...register("facilityType")} className="form-select">
          <option value="">Select Facility Type</option>
          <option value="store">Store</option>
          <option value="workplace">Workplace</option>
          <option value="warehouse">Warehouse</option>
          <option value="office">Office</option>
          <option value="factory">Factory</option>
          <option value="construction">Construction Site</option>
          <option value="school">School</option>
          <option value="hospital">Hospital</option>
          <option value="other">Other</option>
        </select>
        {errors.facilityType && (
          <span className="form-error">{errors.facilityType.message}</span>
        )}
      </div>
    </div>
  );
};

export default Step1CompanyDetails;
